module.exports = __webpack_public_path__ + "static/images/storycastle.e7e1017a93bd24b33d8dae48e8c074ef.jpg";